import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { isTypingTarget } from './hooks';
import { chordActive } from './keys';

/**
 * Listelerde j/k ile seçim, Enter ile açma. Seçili kart görünür alana
 * kaydırılır; seçim yokken ilk j ilk kartı seçer.
 */
export function useStoryKeys(ids: string[]): string | null {
  const [idx, setIdx] = useState(-1);
  const nav = useNavigate();
  const key = ids.join(',');

  useEffect(() => setIdx(-1), [key]);

  useEffect(() => {
    if (ids.length === 0) return;
    const h = (e: KeyboardEvent) => {
      if (isTypingTarget(e.target) || e.metaKey || e.ctrlKey || e.altKey) return;
      if (document.querySelector('[role="dialog"]') || chordActive()) return;
      if (e.key === 'j' || e.key === 'k') {
        e.preventDefault();
        setIdx((i) => {
          const next = e.key === 'j' ? Math.min(ids.length - 1, i + 1) : Math.max(0, i - 1);
          requestAnimationFrame(() =>
            document.querySelector(`[data-story-id="${ids[next]}"]`)?.scrollIntoView({ block: 'center', behavior: 'smooth' })
          );
          return next;
        });
      } else if (e.key === 'Enter' && idx >= 0 && ids[idx] && (e.target === document.body || e.target === document.documentElement)) {
        e.preventDefault();
        nav(`/s/${ids[idx]}`);
      }
    };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, idx, nav]);

  return idx >= 0 ? ids[idx] ?? null : null;
}
